export const FB_APP_ID = '199867687530440';
export const INCENTIVIO_URL = 'https://www.incentivio.com';
